// Runs on every render of a form that came back with server-side errors: the
// public layout preserves the scroll position across the 422 re-render, so the
// participant is still at the submit button while the error sits above it.
export default () => ({
  init() {
    this.$nextTick(() => {
      const invalidField = this.$root.querySelector('.form__field--invalid');
      if (!invalidField) return;

      invalidField.scrollIntoView({ block: 'start', behavior: scrollBehavior() });
      firstFocusable(invalidField)?.focus({ preventScroll: true });
    });
  },
});

const scrollBehavior = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

const firstFocusable = (field) =>
  Array.from(field.querySelectorAll('input, select, textarea')).find(
    (element) => !element.disabled && element.checkVisibility()
  );
